export default "<p>events works!</p>\r\n";